import brLogo from "../../assets/br-logo.png";
import { NAV } from "../constants.js";
import { scrollToId } from "../utils.js";
import { Button } from "../ui/Button.jsx";

export function Header({ activeId }) {
  return (
    <header className="header" id="top">
      <div className="container headerInner">
        <div className="brand" aria-label="Buyrights ЛК">
          <img
            src={brLogo}
            alt=""
            className="brandLogo"
            width="40"
            height="40"
          />
          <span className="brandText">Buyrights ЛК</span>
        </div>

        <nav className="nav" aria-label="Основная навигация">
          {NAV.map((item) => (
            <a
              key={item.id}
              className={`navLink ${activeId === item.id ? "active" : ""}`}
              href={`#${item.id}`}
              onClick={(e) => {
                e.preventDefault();
                scrollToId(item.id);
              }}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="headerCtas">
          {/* <Button variant="ghost" onClick={() => scrollToId("pricing")}>
            Тарифы
          </Button> */}
          <Button onClick={() => scrollToId("cta")}>Связаться</Button>
        </div>
      </div>
    </header>
  );
}

